<template lang="html">
  <div class="row">
    <h1>Goals Component</h1>
  </div>
</template>

<script>
export default {
  name: 'ProfileGoals'
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/pages/ProfileGoals.vue